import Button from "core/buttons/button/Button";
import InfoContext from "pages/InfoContext";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { formatDate } from "utils/helper";
import PropTypes from "prop-types";

export const MissionBody = ({ data, key, lang, setMissionData }) => {
  const { copyMission } = useContext(InfoContext);

  return data
    ? data && (
        <div className="mission-body" key={key}>
          <p>{data?.name}</p>
          <div className="mission-content-wrapper">
            <div className="client-manager">
              <div className="client">
                <FormattedMessage id="client_name" defaultMessage="Client :" />
                <span>{data?.client}</span>
              </div>
              <div className="manager_parent">
                <FormattedMessage
                  id="mission_manager"
                  defaultMessage="Manager :"
                />
                <span>{data?.manager}</span>
              </div>
            </div>
            <div className="date">
              <div className="start-date">
                <FormattedMessage
                  id="mission_start_date"
                  defaultMessage="Date de début"
                />
                <span>{formatDate(data?.start_date, lang)}</span>
              </div>
              <div className="end-date">
                <FormattedMessage
                  id="mission_end_date"
                  defaultMessage="Date de fin"
                />
                <span>
                  {data?.end_date ? formatDate(data?.end_date, lang) : "-"}
                </span>
              </div>
            </div>
          </div>
          <div className="mission-description">
            <FormattedMessage
              id="mission_description"
              deFaultmessage="Description de la mission :"
            />
            <br />
            <span>{data?.description}</span>
          </div>
          <div className="display-flex-space-event ">
            <Button
              className="btn-hover-color"
              size="small"
              color="blue"
              onClick={() => {
                copyMission(data);
                return setMissionData();
              }}
            >
              <FormattedMessage
                id={"copy_mission"}
                defaultMessage={"Copier les informations de la Mission"}
              />
            </Button>
          </div>
        </div>
      )
    : null;
};

MissionBody.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    client: PropTypes.string,
    manager: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    description: PropTypes.string,
  }),
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lang: PropTypes.string,
  setMissionData: PropTypes.func,
};
